export enum Permissions {
  FINANCE_RECEIVER__READ = "FINANCE_RECEIVER__READ",
  FINANCE_RECEIVER__PREPARE_PAYMENT_REFERENCE = "FINANCE_RECEIVER__PREPARE_PAYMENT_REFERENCE",
  FINANCE_RECEIVER__CREATE_UPDATE = "FINANCE_RECEIVER__CREATE_UPDATE",
  FINANCE_RECEIVER__MARK_DELINQUENT = "FINANCE_RECEIVER__MARK_DELINQUENT",
  FINANCE_RECEIVER__DELETE_INTERNAL_NOTES = "FINANCE_RECEIVER__DELETE_INTERNAL_NOTES",
  FINANCE_RECEIVER__REFUND_SURPLUS = "FINANCE_RECEIVER__REFUND_SURPLUS",
  FINANCE_RECEIVER__VALIDATIONS_COLLATERALS = "FINANCE_RECEIVER__VALIDATIONS_COLLATERALS",
  FINANCE_RECEIVER__APPEND_COLLATERAL = "FINANCE_RECEIVER__APPEND_COLLATERAL",
  FINANCE_RECEIVER__ADD_COLLATERAL_ADDITIONAL_DOCUMENT = "FINANCE_RECEIVER__ADD_COLLATERAL_ADDITIONAL_DOCUMENT",
  FINANCE_RECEIVER__ADD_CONTRACTS = "FINANCE_RECEIVER__ADD_CONTRACTS",
  FINANCE_RECEIVER__SET_LEGACY_CURRENT_BALANCE = "FINANCE_RECEIVER__SET_LEGACY_CURRENT_BALANCE",
  FINANCE_RECEIVER__VALIDATIONS_PSD = "FINANCE_RECEIVER__VALIDATIONS_PSD",
  FINANCE_RECEIVER__VALIDATIONS_SEPA = "FINANCE_RECEIVER__VALIDATIONS_SEPA",
  FINANCE_RECEIVER__VALIDATIONS_IDENTITY = "FINANCE_RECEIVER__VALIDATIONS_IDENTITY",
  FINANCE_RECEIVER__VALIDATIONS_FINAL_CHECK = "FINANCE_RECEIVER__VALIDATIONS_FINAL_CHECK",
  FINANCE_RECEIVER__VALIDATIONS_TREATMENT_FEE = "FINANCE_RECEIVER__VALIDATIONS_TREATMENT_FEE",
  FINANCE_RECEIVER__VALIDATIONS_CREATE_QUOTE = "FINANCE_RECEIVER__VALIDATIONS_CREATE_QUOTE",
  FINANCE_RECEIVER__EXPORT = "FINANCE_RECEIVER__EXPORT",

  FINANCE_RECEIVER_REAL_ESTATE__CREATE = "FINANCE_RECEIVER_REAL_ESTATE__CREATE",
  FINANCE_RECEIVER_REAL_ESTATE__UPDATE = "FINANCE_RECEIVER_REAL_ESTATE__UPDATE",
  FINANCE_RECEIVER_REAL_ESTATE__START = "FINANCE_RECEIVER_REAL_ESTATE__START",

  FUNDING_CONTRACTS__READ = "FUNDING_CONTRACTS__READ",
  FUNDING_CONTRACTS__CREATE_UPDATE = "FUNDING_CONTRACTS__CREATE_UPDATE",
  FUNDING_CONTRACTS__UPDATE_IBAN = "FUNDING_CONTRACTS__UPDATE_IBAN",
  FUNDING_CONTRACTS__SET_SENT = "FUNDING_CONTRACTS__SET_SENT",
  FUNDING_CONTRACTS__SET_DRAFT = "FUNDING_CONTRACTS__SET_DRAFT",
  FUNDING_CONTRACTS__SET_SIGNED = "FUNDING_CONTRACTS__SET_SIGNED",
  FUNDING_CONTRACTS__SET_DISSOLVED = "FUNDING_CONTRACTS__SET_DISSOLVED",
  FUNDING_CONTRACTS__SET_CANCELED = "FUNDING_CONTRACTS__SET_CANCELED",
  FUNDING_CONTRACTS__SET_VALIDATED = "FUNDING_CONTRACTS__SET_VALIDATED",
  FUNDING_CONTRACTS__VALIDATE_DEPOSIT = "FUNDING_CONTRACTS__VALIDATE_DEPOSIT",
  FUNDING_CONTRACTS__MANAGE_VALIDATION = "FUNDING_CONTRACTS__MANAGE_VALIDATION",
  FUNDING_CONTRACTS__BOOK_REIMBURSEMENT = "FUNDING_CONTRACTS__BOOK_REIMBURSEMENT",
  FUNDING_CONTRACTS__REVERT_RENEWAL = "FUNDING_CONTRACTS__REVERT_RENEWAL",
  FUNDING_CONTRACTS__ADD_DECLARATION_OF_FUNDS_ADDITIONAL_DOCUMENT = "FUNDING_CONTRACTS__ADD_DECLARATION_OF_FUNDS_ADDITIONAL_DOCUMENT",

  FUNDERS__READ = "FUNDERS__READ",
  FUNDERS__CREATE_UPDATE = "FUNDERS__CREATE_UPDATE",

  PARTNERS__READ = "PARTNERS__READ",
  PARTNERS__CREATE_UPDATE = "PARTNERS__CREATE_UPDATE",

  ADMINS__READ = "ADMINS__READ",
  ADMINS__CREATE_UPDATE = "ADMINS__CREATE_UPDATE",

  USERS_MFA__RESET = "USERS_MFA__RESET",

  LOAN_SUBMISSION__READ = "LOAN_SUBMISSION__READ",
  LOAN_SUBMISSION__MANAGE = "LOAN_SUBMISSION__MANAGE",

  DEVELOPMENT__EXECUTE_COMMANDS = "DEVELOPMENT__EXECUTE_COMMANDS",

  REVOLVING_CREDIT_FACILITY__UPDATE = "REVOLVING_CREDIT_FACILITY__UPDATE",

  REPORT__FINANCIAL = "REPORT__FINANCIAL",

  LOANS__REVALIDATE_DIRECT_DEBITS = "LOANS__REVALIDATE_DIRECT_DEBITS",
  LOANS__ASSESS_RENEWAL_REQUEST = "LOANS__ASSESS_RENEWAL_REQUEST",
  LOANS__BOOK_TRANSFER = "LOANS__BOOK_TRANSFER",

  REAL_ESTATE_LOANS__SCHEDULE_REPAYMENT = "REAL_ESTATE_LOANS__SCHEDULE_REPAYMENT",
  REAL_ESTATE_LOANS__BOOK_TRANSFER = "REAL_ESTATE_LOANS__BOOK_TRANSFER",
}

export enum Roles {
  ADMIN = "admin",
  FUNDER = "funder",
  SALES = "sales",
  PARTNER = "partner",
  SUPERADMIN = "superadmin",
  DEVELOPMENT = "development",
}

export enum FeatureFlags {
  RISK = "risk",
  SHOW_CASHFLOW_V2 = "show_cashflow_v2",
  INVITE_FUNDERS = "invite_funders",
  REAL_ESTATE = "real_estate",
}
